/* eslint-disable spaced-comment */
/* eslint-disable no-shadow */
/* eslint-disable prefer-const */
/* eslint-disable no-nested-ternary */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, createSearchParams, useLocation } from 'react-router-dom';
import { showNotification } from '@mantine/notifications';
import {
  Box,
  Center,
  Image,
  SimpleGrid,
  Card,
  Space,
  Paper,
  Group,
  Modal,
  Stack,
  Radio,
  ActionIcon,
  NumberInput,
  Text,
  Title,
  Button,
  RadioGroup,
} from '@mantine/core';
import { IconX } from '@tabler/icons';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import AppContext from '../../components/Context/index';
import PrimaryButton from '../../components/GroupButton';
import trolley from '../../image/trolley.svg';
import carWash from '../../image/car-wash.svg';
import shuttled from '../../image/bus.png';
import parkingLock from '../../image/parking-lock.svg';
import rentCar from '../../image/car-key.svg';
import backButton from '../../image/backArrow.png';
import quickService from '../../image/maintenance.svg';

// import servicesApi from '../../services/services';
import { sendRequest, sendRequestWithToken } from '../../services/services';

const App = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { t, i18n } = useTranslation();
  const appContextState = useContext(AppContext);
  const { appState } = appContextState;
  const searchParams = new URLSearchParams(search);
  const VasQty = searchParams.get('vas_qty');
  const PassId = searchParams.get('passId');
  const [opened, setOpened] = useState(false);
  const [value, setValue] = useState(1 || parseInt(VasQty, 10));
  // const handlers = useRef<NumberInputHandlers>();
  const [serviceData, setServiceData] = useState([]);

  const [ticketData, setTicketData] = useState();
  const [vasId, setVasId] = useState();
  const [vasSubTypeId, setVasSubTypeId] = useState();
  const [vasName, setVasName] = useState([]);
  const [vasPrice, setVasPrice] = useState();
  const [filteredVas, setFilteredVas] = useState([]);
  const [checked, setChecked] = useState('0');
  const [allService, setAllService] = useState([]);
  const [matchVas, setMatchVas] = useState([]);
  const [buttonEnable, setButtonEnable] = useState(false);
  const siteDetails = JSON.parse(localStorage.getItem('siteDetails'));

  const queryParam = `?long=${siteDetails?.long}&lat=${siteDetails?.long}`;
  useEffect(() => {
    sendRequestWithToken(`sites/${siteDetails?.siteId}/${queryParam}`, 'get').then((res) => {
      setServiceData(res || []);
      if (res === 'empty') {
        showNotification({
          title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
          icon: <IconX />,
        });
      }
    });
  }, [queryParam, vasId]);

  useEffect(() => {
    sendRequest(`sites/vas/list`, 'get').then((res) => {
      setAllService(res || []);
      if (res === 'empty') {
        showNotification({
          title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
          icon: <IconX />,
        });
      }
    });
  }, []);

  useEffect(() => {
    sendRequest(`parking/reservations-by-pass-id/${PassId}`, 'get').then((res) => {
      if (res?.code === 20) {
        setTicketData(res?.data || []);
      } else if (res?.code === 21) {
        showNotification({
          title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
          icon: <IconX size={16} />,
        });
      }
    });
  }, [PassId]);

  const increment = () => {
    //setCount(prevCount => prevCount+=1);
    setValue(function (prevCount) {
      return (prevCount += 1);
    });
  };

  const decrement = () => {
    setValue(function (prevCount) {
      if (prevCount > 1) {
        return (prevCount -= 1);
      }
    });
  };

  const getVas = (vasId) => {
    switch (vasId) {
      case 2:
        return <Title order={5}>Trolly</Title>;
      case 3:
        return <Title order={5}>Shuttle</Title>;

      case 24:
        return <Title order={5}>Car Wash</Title>;

      case 144:
        return <Title order={5}>Quick Service</Title>;
      default:
        return null;
    }
  };

  const description =
    vasId === '2'
      ? 'trolly'
      : vasId === '3'
      ? 'shuttle'
      : vasId === '24'
      ? 'carwash'
      : vasId === '144'
      ? 'quickServices'
      : null;

  const serviceBooking = () => {
    let Vas = {
      reservation_id: Number(ticketData?.result?.id),
      site_id: Number(siteDetails?.siteId),
      status_id: 1,
      vehicle_id: Number(ticketData?.result?.vehicles?.id),
      qty: value,
      vas_type_id: Number(vasId),
      vas_sub_type_id: Number(vasSubTypeId),
      desc: description,
      amount: vasPrice,
    };

    let existingVas = JSON.parse(localStorage.getItem('selectedVas'));
    let filtererdVas = !existingVas ? Vas : existingVas.filter((d) => vasId !== d.vas_Id);
    Vas = existingVas ? [Vas, ...filtererdVas] : [Vas];
    localStorage.setItem('selectedVas', JSON.stringify(Vas));
    navigate({
      pathname: '/userDetails',
      search: createSearchParams({
        passId: PassId,
      }).toString(),
    });
  };

  const goBack = () => {
    navigate({
      pathname: '/addVas',
      search: createSearchParams({
        passId: PassId,
      }).toString(),
    });
    localStorage.removeItem('selectedVas');
  };

  useEffect(() => {
    const grouped = _.mapValues(_.groupBy(serviceData?.data?.site_vas, 'id'), (item) =>
      item.map((car) => _.omit(car, 'id')),
    );

    setFilteredVas(grouped);
  }, [serviceData?.data?.site_vas]);

  const siteVasData = new Map(serviceData?.data?.site_vas?.map((o) => [o.id, o]));

  useEffect(() => {
    const matchedValue = siteVasData;

    setMatchVas([...matchedValue]);
  });

  const onCloseModel = () => {
    setOpened(false);
    if (opened) {
      setButtonEnable(false);
    }
  };

  return (
    <Box>
      <Group>
        <Button
          onClick={goBack}
          color="blue"
          radius="md"
          size="xl"
          leftIcon={<Image src={backButton} width={35} height={20} />}
          px="xl"
        />
        <Space w="xl" />
        <Space w="xl" />
        <Space w="xl" />
        <Space w="xl" />
        <Space w="xl" />
        <Space w="xl" />
        <Center px="xl">
          <Title style={{ color: '#F9D923' }} order={1}>
            {t('choose.other.service.text')}
          </Title>
        </Center>
      </Group>
      <Space h="xl" />

      <Center>
        <SimpleGrid
          cols={3}
          spacing="xl"
          breakpoints={[
            { maxWidth: 980, cols: 3, spacing: 'md' },
            { maxWidth: 755, cols: 2, spacing: 'sm' },
            { maxWidth: 600, cols: 1, spacing: 'sm' },
          ]}
        >
          {/* {serviceData?.data?.site_vas?.map((item) => ( */}
          {matchVas?.map((item) => (
            <Center>
              <Paper
                key={item.id}
                sx={{
                  minHeight: '200px',
                  minWidth: '200px',
                }}
                shadow="sm"
                onClick={() => {
                  if (item?.id === 24 || 2 || 3 || 144) {
                    setOpened(true);
                    setVasId(item[1]?.id);
                    setVasName(item[1]?.vas_types);
                    // setVasPrice(item?.vas_price);
                    // setVasSubTypeId(item?.vas_sub_type_id);
                    // setVasDesc()
                  }
                }}
                // onClick={() => setOpened(true)}
              >
                <Center>
                  <Card key={item.id}>
                    <Center>
                      <Card.Section>
                        {item[1].id === '24' ? (
                          <Image src={carWash} width={50} height={50} />
                        ) : null}
                        {item[1].id === '2' ? <Image src={trolley} width={50} height={50} /> : null}
                        {item[1].id === '3' ? (
                          <Image src={shuttled} width={50} height={50} />
                        ) : null}
                        {item[1].id === '144' ? (
                          <Image src={quickService} width={50} height={50} />
                        ) : null}
                        {item[1].id === '5' ? (
                          <Image src={parkingLock} width={50} height={50} />
                        ) : null}
                        {item[1].id === '7' ? <Image src={rentCar} width={50} height={50} /> : null}
                      </Card.Section>
                    </Center>
                    <Center>
                      {appState?.language === 'en' ? (
                        <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                          <Text weight={500}>{item[1]?.vas_types}</Text>
                        </Group>
                      ) : (
                        <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                          {item[1]?.id === '2' ? (
                            <Text weight={500}>{t('choose.service.trolly.title.text')}</Text>
                          ) : item[1]?.id === '3' ? (
                            <Text weight={500}>{t('choose.service.shuttle.title.text')}</Text>
                          ) : item[1]?.id === '24' ? (
                            <Text weight={500}>{t('choose.service.carwash.title.text')}</Text>
                          ) : item[1]?.id === '144' ? (
                            <Text weight={500}>{t('choose.service.quickService.title.text')}</Text>
                          ) : null}
                        </Group>
                      )}
                    </Center>
                    {/* <Center>
                      {appState?.language === 'en' ? (
                        <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                          <Text weight={500}>{item[1]?.vas_sub_type_name}</Text>
                        </Group>
                      ) : (
                        <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                          {item[1].vas_types === 'Trolley' ? (
                            <Text weight={500}>{t('choose.service.trolly.title.text')}</Text>
                          ) : (
                            <Text weight={500}>{t('choose.service.carwash.title.text')}</Text>
                          )}
                        </Group>
                      )}
                    </Center> */}
                    <Center>
                      <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                        <Text weight={400}>{item[1].desc}</Text>
                      </Group>
                    </Center>
                    <Center>
                      <Group>
                        <Text size="sm" style={{ lineHeight: 1.5 }}>
                          {item[1].vas_price}
                        </Text>
                        <Text weight={500}>{t('ticket.amount.sar.text')}</Text>
                      </Group>
                    </Center>
                    {/* <Box py="lg">
                      <Group>
                        <Text weight={500}>{t('choose.service.open.time')}</Text>
                        <Text size="sm" style={{ lineHeight: 1.5 }}>
                          {item.open_time}
                        </Text>
                      </Group>
                      <Group>
                        <Text weight={500}>{t('choose.service.close.time')}</Text>
                        <Text size="sm" style={{ lineHeight: 1.5 }}>
                          {item.close_time}
                        </Text>
                      </Group>
                    </Box> */}
                  </Card>
                </Center>
              </Paper>
            </Center>
          ))}
        </SimpleGrid>
      </Center>

      <Modal
        centered
        opened={opened}
        overlayOpacity={0.55}
        overlayBlur={3}
        onClose={() => onCloseModel()}
        title={
          vasId === '2' ? (
            <Title order={3}>{t('choose.service.trolly.description')}</Title>
          ) : vasId === '3' ? (
            <Title order={3}>{t('choose.service.shuttle.description')}</Title>
          ) : vasId === '24' ? (
            <Title order={3}>{t('choose.service.carwash.description')}</Title>
          ) : vasId === '144' ? (
            <Title order={3}>{t('choose.service.quickService.description')}</Title>
          ) : null
        }
      >
        <Center>
          {vasId === '24' ? (
            <Box>
              <Group position="apart">
                <Stack>
                  {filteredVas[Number(vasId)]?.map((item) => (
                    <div>
                      {/* <Checkbox
                        value={item?.vas_sub_type_id}
                        label={<Text>{item?.vas_sub_type_name}</Text>}
                        id="1"
                        checked={carWashInside === 'true' ? true : null}
                        onChange={(e) => setCarWashValue1(e.target.checked)}
                        onClick={() => {
                          setVasSubTypeId(item?.vas_sub_type_id);
                          setVasPrice(item?.vas_price);
                        }}
                        disabled={carWashValue2 === true || carWashValue3 === true}
                      /> */}
                      <RadioGroup
                        onChange={() => setChecked(item?.vas_sub_type_id)}
                        value={checked}
                        onClick={() => {
                          setVasSubTypeId(item?.vas_sub_type_id);
                          setVasPrice(item?.vas_price);
                          setButtonEnable(true);
                        }}
                      >
                        <Radio
                          value={item?.vas_sub_type_id}
                          label={<Text size="lg">{item?.vas_sub_type_name}</Text>}
                        />
                      </RadioGroup>
                    </div>
                  ))}
                </Stack>
                <Stack style={{ marginTop: '6.5px' }}>
                  {filteredVas[Number(vasId)]?.map((item) => (
                    <div>
                      <Text size="lg">
                        {item?.vas_price} {t('ticket.amount.sar.text')}
                      </Text>
                    </div>
                  ))}
                </Stack>
              </Group>
              <Center p="xl">
                <Button
                  size="md"
                  color="black"
                  onClick={serviceBooking}
                  disabled={buttonEnable === false}
                >
                  {t('confirm.button.text')}
                </Button>
              </Center>
            </Box>
          ) : vasId === '144' ? (
            <Box>
              <Group position="apart">
                <Stack>
                  {filteredVas[Number(vasId)]?.map((item) => (
                    <div>
                      <RadioGroup
                        onChange={() => setChecked(item?.vas_sub_type_id)}
                        value={checked}
                        onClick={() => {
                          setVasSubTypeId(item?.vas_sub_type_id);
                          setVasPrice(item?.vas_price);
                          setButtonEnable(true);
                        }}
                      >
                        <Radio
                          value={item?.vas_sub_type_id}
                          label={<Text size="lg">{item?.vas_sub_type_name}</Text>}
                        />
                      </RadioGroup>
                    </div>
                  ))}
                </Stack>
                <Stack style={{ marginTop: '6.5px' }}>
                  {filteredVas[Number(vasId)]?.map((item) => (
                    <div>
                      <Text size="lg">
                        {item?.vas_price} {t('ticket.amount.sar.text')}
                      </Text>
                    </div>
                  ))}
                </Stack>
              </Group>
              <Center p="xl">
                <Button
                  size="md"
                  color="black"
                  onClick={serviceBooking}
                  disabled={buttonEnable === false}
                >
                  {t('confirm.button.text')}
                </Button>
              </Center>
            </Box>
          ) : (
            <Box>
              <Group position="apart">
                <Stack>
                  {filteredVas[Number(vasId)]?.map((item) => (
                    <div>
                      <RadioGroup
                        onChange={() => setChecked(item?.vas_sub_type_id)}
                        value={checked}
                        onClick={() => {
                          setVasSubTypeId(item?.vas_sub_type_id);
                          setVasPrice(item?.vas_price);
                          setButtonEnable(true);
                        }}
                      >
                        <Radio
                          value={item?.vas_sub_type_id}
                          label={<Text>{item?.vas_sub_type_name}</Text>}
                        />
                      </RadioGroup>
                    </div>
                  ))}
                </Stack>
                <Stack style={{ marginTop: '6.5px' }}>
                  {filteredVas[Number(vasId)]?.map((item) => (
                    <Text size="lg">
                      {item?.vas_price} {t('ticket.amount.sar.text')}
                    </Text>
                  ))}
                </Stack>
              </Group>

              <Space h="xl" />
              <Group spacing={5}>
                <ActionIcon
                  size={42}
                  variant="default"
                  onClick={() => decrement()}
                  disabled={value === 1}
                >
                  –
                </ActionIcon>

                <NumberInput
                  hideControls
                  value={value || parseInt(VasQty, 10)}
                  onChange={(val) => setValue(val)}
                  // handlersRef={handlers}
                  max={10}
                  min={1}
                  step={2}
                  styles={{ input: { width: 54, textAlign: 'center' } }}
                />
                <ActionIcon size={42} variant="default" onClick={() => increment()}>
                  +
                </ActionIcon>
              </Group>
              <Center p="xl">
                <Button
                  size="md"
                  color="black"
                  onClick={serviceBooking}
                  disabled={buttonEnable === false}
                >
                  {t('confirm.button.text')}
                </Button>
              </Center>
            </Box>
          )}
        </Center>
      </Modal>

      <Space h="xs" />

      {serviceData?.data?.site_vas?.length < 4 ? (
        <>
          <Space h="xl" />
          <Space h="xl" />
          <Space h="xl" />
          <Space h="xl" />
          <Space h="xl" />
          <Space h="xl" />
          <Space h="xl" />
          <Space h="xl" />
          <Space h="xl" />
          <Space h="xl" />
          <Space h="xl" />
        </>
      ) : null}

      <PrimaryButton />
    </Box>
  );
};

export default App;
